<template>
  <div>
    <tool-bar :title="title" subTitle=""></tool-bar>
    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <loading :loading="loading"></loading>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div v-if="showUI">
      <weex-image
        v-if="statusImageLink"
        class="margin_top_20 horizontal_center"
        :src="statusImageLink"
        style="height: 200px;width: 200px;"
      ></weex-image>

      <weex-text
        v-if="instructionHeading"
        v-html="instructionHeading"
        class="font-size-base margin_top_20 margin-left-10 margin-right-10 text-align-center"
      ></weex-text>

      <weex-text
        v-if="instructions && instructions.length"
        class="margin_top_20 margin-left-10 font-size-sm-base font-weight-bold">
        Next Steps
      </weex-text>

      <instructions-item
        class="margin-top-10 margin-left-10 margin-right-10"
        :instructions="instructions"
        :use-bullet-for-indexing="true"
      ></instructions-item>

      <wxc-button
        v-if="showContinueButton"
        text="Continue"
        class="horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="completeCurrentTaskAndGetNextTask"
      ></wxc-button>

      <wxc-button
        v-if="showCloseButton"
        text="Close"
        class="horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="gotoLoanDetails"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import RefreshItem from "../layout/RefreshItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import InstructionsItem from "../layout/InstructionsItem";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";

export default {
  name: "CheckApprovalStatus",
  components: {
    ActivityRedirectItem,
    ToolBar,
    ErrorAlertItem,
    Loading,
    RefreshItem,
    InstructionsItem,
    WxcButton
  },

  data: () => ({
    title: "Approval Status",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    showUI: false,
    statusImageLink: "",
    showContinueButton: false,
    showCloseButton: false,
    instructionHeading: "",
    instructions: []
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    gotoLoanDetails() {
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
        .then(stageConfigRes => {
          this.loading = false;
          if (stageConfigRes.errorOccurred) {
            this.showError(stageConfigRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            const checkApprovalStatusResponse = stageConfigRes.data ? stageConfigRes.data : {};
            this.statusImageLink = checkApprovalStatusResponse.statusImageLink;
            this.instructionHeading = checkApprovalStatusResponse.instructionHeading;
            this.instructions = checkApprovalStatusResponse.instructions;
            if (checkApprovalStatusResponse.moveAhead) {
              this.showContinueButton = true;
            } else {
              this.showCloseButton = true;
            }
          }
        })
    }
  },

  created() {
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.CHECK_APPROVAL_STATUS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

